import Vue from "vue";
const logServeCof = () => {
    return window.isLogoVisible
        ? window.isStarRiver
            ? 'starRiver3D'
            : 'blackHole3D'
        : 'bimEngine3D';
};
export default {
    install(val) {
        Vue.prototype.$logServeCof = (val) => {
            return logServeCof()
        }
    },
    logServeCof
};